const Action = {

    // FIELDS
    "module": "Module",
    "name": "Name",
    "description": "Description",
    "api_endpoint": "API Endpoint",
    "actions": "Actions",
    "route": "Route",
    "show_in_menu": 'Show In Menu',
    "search": "Search",
    "priority": "Priority",

    // PAGE HEADER
    "action": "Action",

    // ERROR
    "error_module": "Select Module",
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_api_endpoint": "Enter API Endpoint",
    "error_route": "Enter Route",
    "error_invalid_route": "Invalid Route",
    "error_show_in_menu": 'Select Show In Menu',
    "error_priority": "Enter Priority",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_module": "MODULE",
    "table_priority": "PRIORITY",

}

export default Action;